// @owners { team: patients }
import { COLORS } from '@alto/design-library-tokens';
import { Body, Column, Illustration, MdSpacing, XlSpacing } from '@alto/design-system';
import React from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { useOnboardingConfirmationViewed } from '~shared/lib/analytics/src/hooks/useOnboardingConfirmationViewed';
import { OnboardingButtonDesktop, OnboardingButtonMobile } from './OnboardingButton';
import { OnboardingNavBarLogo } from './OnboardingNavBarLogo';
import OnboardingPageBackground from './OnboardingPageBackgroundContainer';
import { Header } from '~web/components/HeaderImage';
import { OnboardingContentWrapper } from '~web/components/Page';
import courier from '~web/images/notification@2x.png';

type Props = {
  readonly onContinue: () => void;
  readonly showProgyny: boolean;
  readonly fetchAppDownloadLinkLoading: boolean;
  readonly origin?: string;
};

export const OnboardingProviderSuccess = ({ onContinue, showProgyny, fetchAppDownloadLinkLoading, origin }: Props) => {
  useOnboardingConfirmationViewed(showProgyny, origin);

  const title = `Final step!\nDownload the ${getCompanyName()} app`;
  const subtitle = `The ${getCompanyName()} app is required to schedule your fertility medications for delivery`;
  const buttonCopy = 'Download app';

  return (
    <OnboardingPageBackground>
      <Column
        centerHorizontally
        gap="XXXL"
      >
        <OnboardingNavBarLogo />
        <OnboardingContentWrapper>
          <Column center>
            <Illustration
              source={courier}
              accessibilityLabel={IMG_ALT_TEXTS.bikeCourier}
              size="lg"
            />
            <MdSpacing />
            <Header title={title} />
            <MdSpacing />
            <Body
              color={COLORS.TEXT_COLORS.GREY}
              center
            >
              {subtitle}
            </Body>
            <XlSpacing />

            {showProgyny ? (
              <OnboardingButtonDesktop
                onClick={onContinue}
                loading={fetchAppDownloadLinkLoading}
                label={buttonCopy}
              />
            ) : null}
            {showProgyny ? (
              <OnboardingButtonMobile
                onClick={onContinue}
                loading={fetchAppDownloadLinkLoading}
                label={buttonCopy}
              />
            ) : null}
          </Column>
        </OnboardingContentWrapper>
      </Column>
    </OnboardingPageBackground>
  );
};
